


































import type { PropType } from '@vue/composition-api';
import { computed, onMounted, defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'SlideShowBottomBar',
  props: {
    blockWidth: { type: Object as PropType<Record<string, boolean>>, default: () => ({}) },
    isGridView: { type: Boolean, default: false },
    currentSlide: { type: Number, default: 0 },
    isSelected: { type: Boolean, default: false },
    slides: { type: Number, default: 1 },
    gridSlides: { type: Number, default: 1 },
    isSticky: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const numOfSlides = computed(() => {
      if (props.isGridView) {
        return props.gridSlides;
      }
      return props.slides;
    });

    const handleKeyDown = (e: KeyboardEvent) => {
      if (!props.isSelected) {
        return;
      }
      if (e.key === 'ArrowLeft' || e.code === 'KeyA') {
        emit('slide', -1);
      } else if (e.key === 'ArrowRight' || e.code === 'KeyD') {
        emit('slide', 1);
      }
    };

    onMounted(() => {
      window.addEventListener('keydown', handleKeyDown);
    });

    return {
      numOfSlides,
      handleKeyDown,
    };
  },
});
